import { CheckYesIcon, palette } from "@minervaproject/fds";
import React from "react";

const SuccessMessage = ({ msg, msgStyles = { width: "400px" } }) => {
  if (!msg) return null;

  return (
    <p className="flex body-s mt1 items-center" style={{ color: palette.green }}>
      <span style={msgStyles}>
        <CheckYesIcon
          color={palette.green}
          height="12px"
          width="12px"
          style={{ marginRight: "8px", marginBottom: "-1px" }}
        />
        <span id="js-success">{msg}</span>
      </span>
    </p>
  );
};

export { SuccessMessage };
